// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falY: CreateIconOptions = {
  "displayName": "FALY",
  "viewBox": "0, 0, 384, 512",
  "d": "M28.9 38.5c-5.2-7.1-15.2-8.7-22.4-3.4S-2.1 50.3 3.1 57.5L176 293.2 176 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-170.8L380.9 57.5c5.2-7.1 3.7-17.1-3.4-22.4s-17.1-3.7-22.4 3.4L192 260.9 28.9 38.5z"
};
